<template>
  <b-container class="p-3" fluid>
    <portal to="project-action-bar">
      <b-button variant="success" class="mr-2" @click="submit">
        <font-awesome-icon icon="save" />บันทึก
      </b-button>
      <b-button variant="outline-secondary" @click="discardEdit">
        <font-awesome-icon icon="times" />ยกเลิกการแก้ไข
      </b-button>
    </portal>

    <b-row>
      <b-col>
        <b-alert variant="info" show>
          <font-awesome-icon icon="lightbulb" /><strong>คำแนะนำ</strong> แบบฟอร์มนี้สามารถบันทึกและแก้ไขใหม่ได้จนกว่าจะยืนยันการยื่นขออนุมัติ
        </b-alert>

        <b-form @submit.prevent="submit">
          <create-form-basic-info
            v-model="project"
            class="mb-4"
          />

          <create-form-planning v-model="project.plannedTasks" class="mb-4" />

          <create-form-budget-planning v-bind="project" class="mb-4" />

          <create-form-outcome v-model="project.expectedOutcomes" :expense-summation="expensesSummation" class="mb-4" />

          <create-form-more-info v-model="project" class="mb-4" />
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CreateFormBasicInfo from '@/components/project/create/CreateFormBasicInfo'
import CreateFormPlanning from '@/components/project/create/CreateFormPlanning'
import CreateFormBudgetPlanning from '@/components/project/create/CreateFormBudgetPlanning'
import CreateFormOutcome from '@/components/project/create/CreateFormOutcome'
import CreateFormMoreInfo from '@/components/project/create/CreateFormMoreInfo'

import _ from 'lodash'

export default {
  components: { CreateFormBasicInfo, CreateFormPlanning, CreateFormBudgetPlanning, CreateFormOutcome, CreateFormMoreInfo },
  data () {
    return {
      project: null
    }
  },
  computed: {
    expensesSummation () {
      let summation = 0

      _.each(_.omit(this.project.expenses, '__typename'), group => {
        _.each(group, expense => {
          summation += expense.amountEach * (expense.amountQty > 0 ? expense.amountQty : 1) * (expense.times > 0 ? expense.times : 1) * (expense.qty > 0 ? expense.qty : 1)
        })
      })

      return summation
    }
  },
  created () {
    this.project = _.cloneDeep(this.$store.getters['project/getProject'](this.$route.params.id))

    // Parse Carbon timestamp to JS Date object
    if (this.project.timeframeRaw) {
      this.project.timeframeRaw.start = new Date(this.project.timeframeRaw.start)
      this.project.timeframeRaw.end = new Date(this.project.timeframeRaw.end)
    }

    this.project.plannedTasks = this.project.plannedTasks.map(task => {
      if (task.datetime instanceof Object) {
        task.datetime.start = new Date(task.datetime.start)
        task.datetime.end = new Date(task.datetime.end)
      }
      return task
    })
  },
  methods: {
    async submit () {
      try {
        let project = _.cloneDeep(this.project)

        project.expenses.articles = project.expenses.articles.map(expense => {
          return {
            ...expense,
            amountEach: expense.amountEach === '' ? null : expense.amountEach,
            amountQty: expense.amountQty === '' ? null : expense.amountQty,
            qty: expense.qty === '' ? null : expense.qty,
            times: expense.times === '' ? null : expense.times
          }
        })

        project.expenses.general = project.expenses.general.map(expense => {
          return {
            ...expense,
            amountEach: expense.amountEach === '' ? null : expense.amountEach,
            amountQty: expense.amountQty === '' ? null : expense.amountQty,
            qty: expense.qty === '' ? null : expense.qty,
            times: expense.times === '' ? null : expense.times
          }
        })

        project.expenses.materials = project.expenses.materials.map(expense => {
          return {
            ...expense,
            amountEach: expense.amountEach === '' ? null : expense.amountEach,
            amountQty: expense.amountQty === '' ? null : expense.amountQty,
            qty: expense.qty === '' ? null : expense.qty,
            times: expense.times === '' ? null : expense.times
          }
        })

        project.expenses.people = project.expenses.people.map(expense => {
          return {
            ...expense,
            amountEach: expense.amountEach === '' ? null : expense.amountEach,
            amountQty: expense.amountQty === '' ? null : expense.amountQty,
            qty: expense.qty === '' ? null : expense.qty,
            times: expense.times === '' ? null : expense.times
          }
        })

        project.expenses.utilities = project.expenses.utilities.map(expense => {
          return {
            ...expense,
            amountEach: expense.amountEach === '' ? null : expense.amountEach,
            amountQty: expense.amountQty === '' ? null : expense.amountQty,
            qty: expense.qty === '' ? null : expense.qty,
            times: expense.times === '' ? null : expense.times
          }
        })

        await this.$store.dispatch('project/patchProposal', project)
      } catch (e) {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
        return
      }

      this.$bvToast.toast('บันทึกการเปลี่ยนแปลงสำเร็จ', {
        title: 'แจ้งเตือน',
        variant: 'success',
        solid: true,
        noCloseButton: true
      })
    },
    async discardEdit () {
      if (!await this.$bvModal.msgBoxConfirm(
        'หากยืนยันยกเลิกการแก้ไข ข้อมูลที่ยังไม่ถูกบันทึกจะสูญหาย',
        {
          title: 'ต้องการยกเลิกการแก้ไขโครงการนี้?',
          okTitle: 'ยกเลิกการแก้ไข',
          cancelTitle: 'ไม่',
          centered: true,
          okVariant: 'danger'
        }
      )) {
        return
      }

      setTimeout(() => {
        this.$router.push({ name: 'projects.show.proposal.basic', params: { id: this.project.id } })
      }, 210)
    }
  }
}
</script>
